import { render, staticRenderFns } from "./_base-alert.vue?vue&type=template&id=2c0c590c&"
import script from "./_base-alert.vue?vue&type=script&lang=ts&"
export * from "./_base-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports